import * as Actions from '../actions';
import { validateField } from '../../../utils/FormValidations'

const initialState = {
    list: []
}

const validatorReducer = function (state = initialState, action) {
    switch (action.type) {

        case (Actions.START_VALIDATOR):
            {
                return {
                    ...state,
                    list: action.payload.map((row) => {
                        return {
                            ...row,
                            value: null,
                            error: null,
                            error_msg: '',
                        }
                    })
                }
            }

        case (Actions.RUN_VALIDATOR):
            {
                const is_valid = action.payload.results.every(r => r.status === true)
                let new_list = state.list.map((row) => {
                    if (action.payload.field_name === row.field_name) {
                        return {
                            ...row,
                            value: action.payload.value,
                            error: !is_valid,
                            error_msg: is_valid ? '' : action.payload.results.map(r => r.error_message)
                        }
                    }
                    return row
                })
                return {
                    ...state,
                    list: new_list
                }
            }

        default:
            {
                return state;
            }

    }
}

export default validatorReducer;


// WEBPACK FOOTER //
// src/main/components/validator/store/reducers/validator.reducer.js